import { Outlet } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import BgImage from "~/ui/shared/assets/BG.png";
import LogoImage from "~/ui/shared/assets/logo.png";
import LogoTipo from "~/ui/shared/assets/LogoTipo.png";
import { YoutubeIcon } from "~/ui/shared/icons/youtube";
import { FacebookIcon } from "~/ui/shared/icons/facebook";
import { InstagramIcon } from "~/ui/shared/icons/instagram";
import { getGeneralConfig } from "~/data/general/general.service";

export function AuthLayout() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 h-screen">
      <aside className="hidden md:flex relative bg-primary-1 text-white flex-col items-center h-full overflow-hidden py-24">
        {/* Background Image and Gradient Overlay */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${BgImage})` }}
        >
          <div
            className="w-full h-full opacity-80"
            style={{
              backgroundImage:
                "linear-gradient(223.15deg, #246CAB 12.21%, #062037 83.68%)",
            }}
          />
        </div>

        {/* Logo and Title Section */}
        <div className="relative flex flex-col items-center gap-4">
          <div className="flex flex-col items-center">
            <div className="w-40 h-40 p-5 mb-2 bg-white rounded-full flex items-center justify-center">
              <img
                src={LogoImage}
                alt="Logo Pratique Revalida"
                className="w-full h-full object-cover rounded-full"
              />
            </div>
            <h2 className="text-center text-white text-4xl font-bold">
              Pratique Revalida
            </h2>
          </div>
        </div>

        {/* Description Section */}
        <div className="relative mt-auto flex flex-col items-center">
          <p
            className="text-white text-3xl font-semibold text-center max-w-full"
            style={{ width: 475 }}
          >
            Estude para o exame Revalida, realize simulações com seus amigos e
            acompanhe seus resultados com
            <br />a análise de IA.
          </p>
        </div>

        {/* Social Links */}
        <div className="relative flex flex-col items-center mt-auto">
          <p
            className="text-white text-sm font-bold max-w-full text-center"
            style={{ width: 265 }}
          >
            Para acompanhar as novidades da plataforma Pratique Revalida, acesse
            nossas redes sociais!
          </p>
          <SocialLinks />
        </div>
      </aside>

      {/* Main Content */}
      <main className="bg-white">
        <div className="h-full flex flex-col justify-between mx-auto px-4 lg:px-8 py-12 lg:py-24 max-w-xl">
          <div>
            <div className="flex flex-col gap-4 items-center mb-5 lg:mb-20">
              <img
                src={LogoTipo}
                height={95}
                alt="Logotipo Pratique Revalida"
              />
              <p className="text-surface-foreground-variant text-base lg:text-xl font-bold text-center">
                Bem vindo à plataforma{" "}
                <span className="text-secondary-1">Pratique Revalida</span>!
              </p>
            </div>
            <Outlet />
          </div>
          <footer className="w-full justify-center items-center leading-3 mt-auto">
            <span className="block font-semibold text-center text-[#979797] text-xs">
              2024 - Pratique Revalida <br /> Tecnologia para o futuro da
              medicina - Todos os direitos reservados.
            </span>
          </footer>
        </div>
      </main>
    </div>
  );
}

function SocialLinks() {
  const { data: config } = useQuery({
    queryKey: ["general"],
    queryFn: () => getGeneralConfig(),
    staleTime: Infinity,
  });

  const links = [
    {
      href: config?.facebook_link ?? "#",
      label: "Facebook Icon",
      icon: <FacebookIcon className="text-white" />,
    },
    {
      href: config?.instagram_link ?? "#",
      label: "Instagram Icon",
      icon: <InstagramIcon className="text-white" />,
    },
    {
      href: config?.youtube_link ?? "#",
      label: "Youtube Icon",
      icon: <YoutubeIcon className="text-white" />,
    },
  ];

  return (
    <nav className="flex items-center justify-center gap-5 mt-4">
      {links.map((attrs) => (
        <a key={attrs.label} href={attrs.href} aria-label={attrs.label}>
          {attrs.icon}
        </a>
      ))}
    </nav>
  );
}
